export const PreOnboardingEndpoints = {
  getQuestionnaireStatus: 'getQuestionnaireStatus',
  updateStoreQuestionnaireStatus: 'updateQuestionnaireStatus',
  getQuestionnaireOptions: 'getQuestionnaireOptions',
  createQuestionnaireStorePreferences: 'createQuestionnaireStorePreferences',
} as const;
